import React from 'react';

class Snippets extends React.Component{ 
    constructor(props){
        super(props);

        this.snippets = [
            [
                ["см.", "<i>см.</i> <a href=\"#...\">...</a>"],
                ["ср.", "<i>ср.</i> <a href=\"#...\">...</a>"],
                ["ант.", "<i>ант.</i> <a href=\"#...\">...</a>"],
                ["сокр.", "<i>сокр.</i> <a href=\"#...\">...</a>"]
            ],
            [
                ["англ.", "<i>англ.</i>"],
                ["нем.", "<i>нем.</i>"],
                ["голл.", "<i>голл.</i>"],
                ["санскр.", "<i>санскр.</i>"],
                ["фр.", "<i>фр.</i>"]
            ],
            [
                ["тж.", "<i>тж.</i>"],
                ["тк.", "<i>тк.</i>"],
                ["уст.", "<i>уст.</i>"],
                ["букв.", "<i>букв.</i>"],
                ["напр.", "<i>напр.</i>"],
                ["обр.", "<i>обр.</i>"],
                ["связ.", "<i>связ.</i>"]
            ]
        ];

        this.onClick = this.onClick.bind(this);
    }

    onClick(c){
        this.props.onClick(c)
    }

    render(){
        return (
            <div className="popover bs-popover-bottom shadow">
                <div className="arrow"></div>
                <div className="popover-body">
                    {this.snippets.map(snippet_group => (
                        <div className="symbols d-flex flex-wrap mt-3">
                            {snippet_group.map(snippet => (
                                <button 
                                    key={snippet[0]}
                                    className="btn btn-outline-secondary btn-sm mr-2" 
                                    onMouseDown={()=>this.onClick(snippet[1])} 
                                    title={snippet[1]}
                                >
                                    {snippet[0]}
                                </button>
                            ))}
                        </div>
                    ))}
                    <span className="fa fa-times close" onClick={this.props.onClose}></span>        
                </div>
            </div>
        )
    }

}

export default Snippets;